/**
 * Copyright Mántum All Rights Reserved.
 */
import Color from '../color';

const KEY_BATCH = 'batch';
const KEY_COLOR = 'color';
const KEY_TATTOO = 'tattoo';
const KEY_CONSECUTIVE = 'consecutive';

type PropTypes = {
    name?: string;
    value?: Record<string, string>;
    advanced?: {
        message?: string;
    };
};

export default function Batch(props: PropTypes) {
    // prettier-ignore
    const {
        advanced = {}
    } = props

    // prettier-ignore
    const {
        message = ''
    } = advanced

    return (
        <div className='flex items-center justify-start gap-2'>
            {!props.value && message && (
                <div className='text-gray-600 text-base'>{message}</div>
            )}
            {props.value && (
                <>
                    <div className='flex items-center justify-start gap-2 text-gray-600'>
                        <div className='relative'>
                            <Color
                                advanced={{ allowInput: false }}
                                disabled={true}
                                name={props.name}
                                optional={false}
                                value={props.value?.[KEY_COLOR] ?? undefined}
                            />
                        </div>
                        <div className='truncate min-w-36'>
                            <p className='text-sm'>
                                {props.value?.[KEY_BATCH] ?? ''}
                            </p>
                            <p className='text-2xl'>
                                {props.value?.[KEY_TATTOO] ?? ''}
                            </p>
                        </div>
                    </div>
                    {props.value?.[KEY_CONSECUTIVE] && (
                        <div className='text-3xl font-medium text-gray-900'>
                            {props.value?.[KEY_CONSECUTIVE]}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
